import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import styles from './HistoryDialog.module.sass'
import SegmentedControl from '@jimmyboys/liita-ui/dist/components/SegmentedControl'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { CoordinatorType } from 'utils/enums'
import { useState } from 'react'
import CoordinatorHistoryDialog from './CoordinatorHistoryDialog'
import ProviderHistoryDialog from './ProviderHistoryDialog'

const renderSelectedTab = (selectedTab, processId) => {
	switch (selectedTab) {
		case CoordinatorType.FinalSituationPrevisionCoordinator:
		case CoordinatorType.ClinicalCoordinator:
		case CoordinatorType.AdministrativeManager:
			return (
				<CoordinatorHistoryDialog data={{ selectedTab, processId }} />
			)
		default:
			return <ProviderHistoryDialog data={{ processId }} />
	}
}

const CoordinatorAndProviderHistoryDialog = (props) => {
	const { data } = props
	const { processId } = data
	const { i18n } = useGlobal()

	const tabs = [
		{
			id: 'Provider',
			text: i18n`Provider`,
		},
		{
			id: CoordinatorType.FinalSituationPrevisionCoordinator,
			text: i18n`IPP`,
		},
		{
			id: CoordinatorType.ClinicalCoordinator,
			text: i18n`Clinical`,
		},
		{
			id: CoordinatorType.AdministrativeManager,
			text: i18n`Administrative`,
		},
	]
	const [selectedTab, setSelectedTab] = useState(tabs[0].id)

	return (
		<VStack
			className={`${styles['history-root']} ${styles['--coordinator-history']}`}
		>
			<SegmentedControl
				className={styles['history-segment-control']}
				selectedTab={selectedTab}
				onSelect={(e) => {
					setSelectedTab(e.id)
				}}
				selectorType={'border'}
				tabs={tabs}
			/>
			{renderSelectedTab(selectedTab, processId)}
		</VStack>
	)
}

export default CoordinatorAndProviderHistoryDialog
